import faceSaraChen from "../assets/face-sara-chen.png";
import faceHeartInstitute from "../assets/face-heart-institute.png";
import logoSleepDeepDive from "../assets/logo-sleep-deep-dive.png";

// ─── Illustrative skill colors ───────────────────────────────────────────────
// These are example values only. Real skills define their own lead color.
// The platform renders them faithfully — it never overrides or reassigns.
const SKILLS = [
  {
    id: "sleep",
    name: "Sleep Deep Dive",
    creator: "Dr. Sara Chen",
    category: "Recovery",
    color: "#4A90D9",
    insight: "Your deep sleep dropped 18% this week.",
  },
  {
    id: "nutrition",
    name: "Metabolic Load",
    creator: "NutriLab",
    category: "Nutrition",
    color: "#E8853A",
    insight: "Meal timing shifted earlier — glucose stable.",
  },
  {
    id: "cardio",
    name: "Cardio Baseline",
    creator: "Heart Institute",
    category: "Cardiovascular",
    color: "#D9536A",
    insight: "Resting HR down 4 bpm over 30 days.",
  },
];

// ─── Demo components ─────────────────────────────────────────────────────────

function PlatformChromeDemo() {
  return (
    <div
      style={{
        borderRadius: 16,
        overflow: "hidden",
        border: "1px solid rgba(0,0,0,0.06)",
        background: "#F7F7F5",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 8,
          padding: "10px 14px",
          borderBottom: "1px solid rgba(0,0,0,0.05)",
          background: "rgba(255,255,255,0.75)",
        }}
      >
        <span
          style={{
            fontFamily: "'Cormorant Garamond', serif",
            fontSize: 16,
            fontWeight: 700,
            color: "#1F2421",
          }}
        >
          Kin
        </span>
        <div style={{ display: "flex", gap: 2, marginLeft: 8 }}>
          {["Home", "Skills", "Vault"].map((item, i) => (
            <div
              key={item}
              style={{
                padding: "3px 9px",
                borderRadius: 7,
                fontSize: 10,
                fontWeight: 600,
                background: i === 0 ? "#2FB56A" : "transparent",
                color: i === 0 ? "#fff" : "#877e76",
              }}
            >
              {item}
            </div>
          ))}
        </div>
      </div>
      <div style={{ padding: "12px 14px", display: "flex", flexDirection: "column", gap: 8 }}>
        <div
          style={{
            height: 8,
            borderRadius: 5,
            background: "rgba(0,0,0,0.06)",
            width: "55%",
          }}
        />
        <div
          style={{
            height: 6,
            borderRadius: 5,
            background: "rgba(0,0,0,0.04)",
            width: "35%",
          }}
        />
        <div
          style={{
            marginTop: 4,
            padding: "8px 10px",
            borderRadius: 10,
            background: "rgba(255,255,255,0.8)",
            border: "1px solid rgba(0,0,0,0.05)",
          }}
        >
          <div style={{ fontSize: 9, color: "#877e76", marginBottom: 5 }}>
            System action — no personality color
          </div>
          <div style={{ display: "flex", gap: 6 }}>
            <div
              style={{
                padding: "5px 12px",
                borderRadius: 7,
                background: "#2FB56A",
                fontSize: 10,
                fontWeight: 700,
                color: "#fff",
              }}
            >
              Confirm
            </div>
            <div
              style={{
                padding: "5px 12px",
                borderRadius: 7,
                background: "rgba(0,0,0,0.04)",
                border: "1px solid rgba(0,0,0,0.07)",
                fontSize: 10,
                fontWeight: 600,
                color: "#877e76",
              }}
            >
              Cancel
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function HomeScreenDemo() {
  return (
    <div
      style={{
        borderRadius: 16,
        overflow: "hidden",
        border: "1px solid rgba(0,0,0,0.06)",
        background: "#F7F7F5",
        padding: "12px 10px",
        display: "flex",
        flexDirection: "column",
        gap: 6,
      }}
    >
      {/* Kin curation label — neutral, no color */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "0 4px 4px",
        }}
      >
        <span
          style={{
            fontSize: 9,
            fontWeight: 700,
            color: "#877e76",
            letterSpacing: "0.1em",
            textTransform: "uppercase",
          }}
        >
          Most relevant today
        </span>
        <span style={{ fontSize: 9, color: "#b0a89f" }}>3 skills</span>
      </div>

      {/* Featured skill — slightly more prominent */}
      <div
        style={{
          borderRadius: 12,
          padding: "10px 12px",
          background: `${SKILLS[0].color}14`,
          border: `1px solid ${SKILLS[0].color}28`,
        }}
      >
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <span
            style={{
              fontSize: 8,
              fontWeight: 700,
              color: SKILLS[0].color,
              letterSpacing: "0.1em",
              textTransform: "uppercase",
            }}
          >
            {SKILLS[0].category}
          </span>
          <div style={{ width: 6, height: 6, borderRadius: "50%", background: SKILLS[0].color }} />
        </div>
        <div
          style={{
            fontSize: 12,
            fontWeight: 700,
            color: "#1F2421",
            fontFamily: "'Cormorant Garamond', serif",
            marginTop: 3,
          }}
        >
          {SKILLS[0].name}
        </div>
        <div style={{ fontSize: 9, color: "#4F5D56", marginTop: 2, lineHeight: 1.4 }}>
          {SKILLS[0].insight}
        </div>
        <div style={{ fontSize: 8, color: "#877e76", marginTop: 4 }}>{SKILLS[0].creator}</div>
      </div>

      {/* Remaining skills — same shell */}
      {SKILLS.slice(1).map((skill) => (
        <div
          key={skill.id}
          style={{
            borderRadius: 10,
            padding: "8px 10px",
            background: `${skill.color}0d`,
            border: `1px solid ${skill.color}20`,
            display: "flex",
            alignItems: "center",
            gap: 8,
          }}
        >
          <div
            style={{
              width: 5,
              height: 5,
              borderRadius: "50%",
              background: skill.color,
              flexShrink: 0,
            }}
          />
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontSize: 10, fontWeight: 700, color: "#1F2421" }}>{skill.name}</div>
            <div style={{ fontSize: 8, color: "#6F7D76", marginTop: 1 }}>{skill.insight}</div>
          </div>
        </div>
      ))}
    </div>
  );
}

function SkillViewDemo() {
  const skill = SKILLS[0];
  return (
    <div
      style={{
        borderRadius: 16,
        overflow: "hidden",
        border: "1px solid rgba(0,0,0,0.06)",
        background: `${skill.color}08`,
      }}
    >
      {/* Minimal platform chrome */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 6,
          padding: "8px 12px",
          borderBottom: `1px solid ${skill.color}18`,
        }}
      >
        <span style={{ fontSize: 9, color: "#877e76" }}>← Back</span>
        <span style={{ fontSize: 9, color: "#b0a89f", marginLeft: "auto" }}>Kin</span>
      </div>
      {/* Skill header — full color */}
      <div
        style={{
          padding: "14px 14px 10px",
          background: `${skill.color}18`,
          borderBottom: `1px solid ${skill.color}20`,
        }}
      >
        <div
          style={{
            fontSize: 8,
            fontWeight: 700,
            color: skill.color,
            letterSpacing: "0.12em",
            textTransform: "uppercase",
            marginBottom: 4,
          }}
        >
          {skill.category} · {skill.creator}
        </div>
        <div
          style={{
            fontSize: 18,
            fontWeight: 700,
            color: "#1F2421",
            fontFamily: "'Cormorant Garamond', serif",
            lineHeight: 1.15,
          }}
        >
          {skill.name}
        </div>
      </div>
      {/* Skill data — skill owns this */}
      <div style={{ padding: "10px 12px", display: "flex", flexDirection: "column", gap: 6 }}>
        {[
          ["Sleep score", "84 / 100"],
          ["Deep sleep", "1h 42m"],
          ["Recovery", "High"],
        ].map(([label, value]) => (
          <div
            key={label}
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "6px 10px",
              borderRadius: 8,
              background: "rgba(255,255,255,0.7)",
              border: `1px solid ${skill.color}14`,
            }}
          >
            <span style={{ fontSize: 9, color: "#4F5D56" }}>{label}</span>
            <span style={{ fontSize: 11, fontWeight: 700, color: skill.color }}>{value}</span>
          </div>
        ))}
        <div
          style={{
            marginTop: 2,
            padding: "7px 12px",
            borderRadius: 8,
            background: skill.color,
            fontSize: 10,
            fontWeight: 700,
            color: "#fff",
            textAlign: "center",
          }}
        >
          Run full analysis
        </div>
      </div>
    </div>
  );
}

function FailureCaseDemo() {
  const skill = SKILLS[2]; // cardio — uses a different skill to show it's not skill-specific
  return (
    <div
      style={{
        borderRadius: 14,
        overflow: "hidden",
        border: `1px solid ${skill.color}20`,
        background: `${skill.color}06`,
        maxWidth: 340,
      }}
    >
      <div
        style={{
          padding: "12px 14px 8px",
          background: `${skill.color}10`,
          borderBottom: `1px solid ${skill.color}18`,
        }}
      >
        <div
          style={{
            fontSize: 8,
            fontWeight: 700,
            color: skill.color,
            letterSpacing: "0.12em",
            textTransform: "uppercase",
          }}
        >
          {skill.category} · {skill.creator}
        </div>
        <div
          style={{
            fontSize: 16,
            fontWeight: 700,
            color: "#1F2421",
            fontFamily: "'Cormorant Garamond', serif",
            marginTop: 3,
          }}
        >
          {skill.name}
        </div>
      </div>
      {/* Platform-controlled empty state */}
      <div
        style={{
          padding: "14px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 8,
          textAlign: "center",
        }}
      >
        <div
          style={{
            width: 36,
            height: 36,
            borderRadius: "50%",
            background: "rgba(0,0,0,0.04)",
            border: "1px solid rgba(0,0,0,0.07)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#877e76"
            strokeWidth="1.8"
            strokeLinecap="round"
          >
            <circle cx="12" cy="12" r="9" />
            <path d="M12 8v4m0 4h.01" />
          </svg>
        </div>
        {/* Kin speaks — neutral, factual */}
        <div>
          <div style={{ fontSize: 11, fontWeight: 700, color: "#1F2421" }}>Data needed</div>
          <div
            style={{ fontSize: 9, color: "#6F7D76", lineHeight: 1.5, marginTop: 3, maxWidth: 200 }}
          >
            This skill needs recent heart rate data to run. Connect your device or upload a new
            export.
          </div>
        </div>
        <div
          style={{
            padding: "5px 14px",
            borderRadius: 7,
            background: "#2FB56A",
            fontSize: 9,
            fontWeight: 700,
            color: "#fff",
          }}
        >
          Connect data source
        </div>
      </div>
    </div>
  );
}

// ─── Section ─────────────────────────────────────────────────────────────────

export default function PlatformAndSkill() {
  return (
    <section
      id="platform-skill"
      className="kin-section-glow border-t border-kin-olive/10 px-6 py-14 scroll-mt-16 sm:px-8 sm:py-16 gradient-wash"
    >
      <div className="mx-auto max-w-6xl">
        {/* ── Header ── */}
        <p className="text-sm font-semibold tracking-[0.22em] uppercase text-kin-muted">
          04 — Platform
        </p>
        <div className="mt-6 max-w-3xl">
          <h2 className="font-serif text-4xl font-bold leading-tight text-kin-black sm:text-5xl">
            In product moments,
            <br />
            the skill leads.
          </h2>
          <p className="mt-4 text-base leading-relaxed text-kin-body/90 sm:text-lg">
            Kin is the trust container, marketplace, vault, and entry point. But inside a product
            moment — when a user is reading a sleep analysis or reviewing a cardiology report — Kin
            steps back completely. The skill owns the canvas. The platform's job is to make that
            possible.
          </p>
        </div>

        {/* ── Block A: Two roles ── */}
        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2">
          <div className="kin-surface-strong rounded-[24px] p-6 sm:p-7">
            <div className="flex items-center gap-2 mb-4">
              <div className="h-2 w-2 rounded-full bg-kin-green shrink-0" />
              <p className="text-[10px] font-semibold tracking-[0.18em] uppercase text-kin-muted">
                Kin's role
              </p>
            </div>
            <p className="font-serif text-2xl font-bold text-kin-black">Kin curates.</p>
            <p className="mt-3 text-sm leading-relaxed text-kin-body/85">
              The home screen, marketplace, and vault chrome are Kin's territory. When a user has
              more skills than the home screen can show, Kin decides what surfaces and in what
              order. This is where Kin's intelligence is legible — not through visual dominance, but
              through the quality of those curation decisions.
            </p>
            <div className="mt-5 space-y-2">
              {[
                "Orders home screen widgets by relevance",
                "Surfaces cross-skill patterns and trends",
                "Manages the vault, auth, and system surfaces",
                "Controls empty and error states",
              ].map((item) => (
                <div key={item} className="flex items-start gap-2">
                  <div className="mt-1.5 h-1.5 w-1.5 rounded-full bg-kin-green/60 shrink-0" />
                  <p className="text-xs text-kin-body/80">{item}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="kin-surface rounded-[24px] p-6 sm:p-7">
            <div className="flex items-center gap-2 mb-4">
              <div className="h-2 w-2 rounded-full bg-kin-lavender shrink-0" />
              <p className="text-[10px] font-semibold tracking-[0.18em] uppercase text-kin-muted">
                Skill's role
              </p>
            </div>
            <p className="font-serif text-2xl font-bold text-kin-black">Skills lead.</p>
            <p className="mt-3 text-sm leading-relaxed text-kin-body/85">
              Inside a skill's own view, the platform collapses to its minimum — a thin nav bar, a
              back gesture, system-level actions. The skill owns the visual moment: its color, its
              data presentation, its voice. A sleep coach and a cardiology tool should feel like
              distinct products that happen to share a platform.
            </p>
            <div className="mt-5 space-y-2">
              {[
                "Owns its lead color across all surfaces",
                "Controls its own voice and data presentation style",
                "Defines what counts as a meaningful insight",
                "Decides how its output is structured",
              ].map((item) => (
                <div key={item} className="flex items-start gap-2">
                  <div className="mt-1.5 h-1.5 w-1.5 rounded-full bg-kin-lavender/60 shrink-0" />
                  <p className="text-xs text-kin-body/80">{item}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* ── Block B: Visual layers ── */}
        <div className="mt-10">
          <p className="text-xs font-semibold tracking-[0.2em] uppercase text-kin-muted mb-5">
            Visual layers — brightness follows depth
          </p>
          <div className="grid grid-cols-1 gap-5 lg:grid-cols-3">
            {[
              {
                number: "01",
                label: "Platform chrome",
                rule: "Neutral by default. Green only where interaction happens.",
                dot: "#2FB56A",
                Demo: PlatformChromeDemo,
                detail:
                  "Navigation, system actions, and vault surfaces carry no personality color. Kin green appears on buttons and active states only.",
              },
              {
                number: "02",
                label: "Home screen",
                rule: "Skills at reduced brightness. Recognizable, not competing.",
                dot: "#877e76",
                Demo: HomeScreenDemo,
                detail:
                  "Consistent card shell across all widgets. Skill lead color appears as a 12–15% tint. One full-saturation accent element per card — the eyebrow label or status dot.",
              },
              {
                number: "03",
                label: "Inside a skill",
                rule: "Full color. The platform disappears.",
                dot: "#4A90D9",
                Demo: SkillViewDemo,
                detail:
                  "Platform chrome collapses to a minimal nav bar. The skill owns the canvas — its color runs at full saturation across the full surface.",
              },
            ].map(({ number, label, rule, dot, Demo, detail }) => (
              <div key={number} className="kin-surface rounded-[24px] p-5 flex flex-col gap-4">
                <div>
                  <div className="flex items-center gap-2 mb-2">
                    <div className="h-2 w-2 rounded-full shrink-0" style={{ background: dot }} />
                    <p className="text-[10px] font-semibold tracking-[0.16em] uppercase text-kin-muted">
                      Layer {number}
                    </p>
                  </div>
                  <p className="text-sm font-semibold text-kin-black">{label}</p>
                  <p className="mt-0.5 text-xs italic text-kin-body/65">{rule}</p>
                </div>
                <Demo />
                <p className="text-xs leading-relaxed text-kin-body/80">{detail}</p>
              </div>
            ))}
          </div>
        </div>

        {/* ── Block C: Three moments Kin speaks ── */}
        <div className="mt-10 kin-surface rounded-[24px] p-6 sm:p-8">
          <p className="text-xs font-semibold tracking-[0.2em] uppercase text-kin-muted mb-5">
            The three moments Kin speaks
          </p>
          <div className="space-y-3">
            {[
              {
                moment: "System chrome",
                visual: "Green — platform owns this entirely",
                example: "Navigation, authentication, settings, vault access.",
                dot: "#2FB56A",
              },
              {
                moment: "Curation label",
                visual: "Neutral text, no color — Kin as editor, not brand",
                example: '"3 skills updated today." / "Most relevant for you."',
                dot: "#877e76",
              },
              {
                moment: "Cross-skill synthesis",
                visual: "Blue — surface skill data, Kin adds the frame",
                example: '"Your recovery trend across all skills this week."',
                dot: "#4A90D9",
              },
            ].map((row) => (
              <div
                key={row.moment}
                className="grid grid-cols-1 gap-2 rounded-[18px] border border-kin-olive/10 bg-kin-white/60 p-4 sm:grid-cols-[160px_1fr_1fr]"
              >
                <div className="flex items-center gap-2">
                  <div className="h-2 w-2 rounded-full shrink-0" style={{ background: row.dot }} />
                  <p className="text-xs font-semibold text-kin-black">{row.moment}</p>
                </div>
                <p className="text-xs text-kin-body/80">{row.visual}</p>
                <p className="text-xs italic text-kin-body/65">{row.example}</p>
              </div>
            ))}
          </div>
        </div>

        {/* ── Block D: Language model ── */}
        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2">
          <div className="kin-surface rounded-[24px] p-6">
            <p className="text-xs font-semibold tracking-[0.2em] uppercase text-kin-muted mb-4">
              Kin curator voice
            </p>
            <p className="text-xs text-kin-body/75 mb-4 leading-relaxed">
              Short. Factual. No personality. States facts about data or curation decisions. Never
              rewrites or summarizes skill output.
            </p>
            <div className="space-y-2">
              {[
                "3 skills have new insights today.",
                "Sleep guide flagged a pattern worth reviewing.",
                "Your recovery this week: improving across 2 skills.",
                "This skill needs updated data to run.",
              ].map((line) => (
                <div
                  key={line}
                  className="rounded-[12px] border border-kin-olive/10 bg-kin-white/70 px-3 py-2"
                >
                  <p className="text-xs text-kin-body">{line}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="kin-surface rounded-[24px] p-6">
            <p className="text-xs font-semibold tracking-[0.2em] uppercase text-kin-muted mb-4">
              Skill voices — distinct, unfiltered
            </p>
            <p className="text-xs text-kin-body/75 mb-4 leading-relaxed">
              Skills speak with their own voice. The platform does not homogenize this. A sleep
              coach may be warm; a cardiology tool may be precise and clinical.
            </p>
            <div className="space-y-3">
              {[
                {
                  skill: "Sleep Deep Dive",
                  color: SKILLS[0].color,
                  text: "Your body is telling you something. Deep sleep dropped 18% — let's look at what changed.",
                },
                {
                  skill: "Cardio Baseline",
                  color: SKILLS[2].color,
                  text: "Resting HR: 58 bpm (↓4 bpm, 30d). HRV within reference range. No flags.",
                },
                {
                  skill: "Metabolic Load",
                  color: SKILLS[1].color,
                  text: "Earlier meals = more stable glucose today. Keep going.",
                },
              ].map(({ skill, color, text }) => (
                <div
                  key={skill}
                  className="rounded-[12px] p-3"
                  style={{
                    background: `${color}0d`,
                    border: `1px solid ${color}22`,
                  }}
                >
                  <p
                    className="text-[9px] font-semibold uppercase tracking-[0.1em] mb-1.5"
                    style={{ color }}
                  >
                    {skill}
                  </p>
                  <p className="text-xs leading-relaxed text-kin-body/85">{text}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* ── Block E: Skill ownership limits ── */}
        <div className="mt-8 kin-surface rounded-[24px] p-6 sm:p-8">
          <p className="text-xs font-semibold tracking-[0.2em] uppercase text-kin-muted mb-5">
            Skill ownership — what varies, what must stay consistent
          </p>
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            <div>
              <p className="text-[10px] font-semibold tracking-[0.14em] uppercase text-kin-green-dark mb-3">
                Skills may vary
              </p>
              <div className="space-y-2">
                {[
                  ["Lead color", "Platform renders it at correct brightness for context"],
                  ["Voice and tone", "Warm coach, precise clinical, motivational — all valid"],
                  ["Data presentation", "Charts, scores, narratives, timelines"],
                  ["Insight structure", "What counts as a meaningful output for that skill"],
                ].map(([title, desc]) => (
                  <div
                    key={title}
                    className="rounded-[12px] border border-kin-olive/10 bg-kin-white/60 px-3 py-2.5"
                  >
                    <p className="text-xs font-semibold text-kin-black">{title}</p>
                    <p className="text-[10px] text-kin-body/70 mt-0.5">{desc}</p>
                  </div>
                ))}
              </div>
            </div>
            <div>
              <p className="text-[10px] font-semibold tracking-[0.14em] uppercase text-kin-muted mb-3">
                Must stay platform-consistent
              </p>
              <div className="space-y-2">
                {[
                  [
                    "Card shell on home screen",
                    "Same shape, radius, and elevation across all skill widgets",
                  ],
                  [
                    "Type scale",
                    "Manrope for data, Cormorant Garamond for display — skills may not override fonts",
                  ],
                  [
                    "Lavender",
                    "Reserved for AI-generated content only. Skills may not repurpose it",
                  ],
                  ["Elevation model", "Tint hierarchy across platform / home / skill layers"],
                ].map(([title, desc]) => (
                  <div
                    key={title}
                    className="rounded-[12px] border border-kin-olive/10 bg-kin-white/60 px-3 py-2.5"
                  >
                    <p className="text-xs font-semibold text-kin-black">{title}</p>
                    <p className="text-[10px] text-kin-body/70 mt-0.5">{desc}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* ── Block E2: Skill color framework ── */}
        <div className="mt-8 kin-surface rounded-[24px] p-6 sm:p-8">
          <p className="text-xs font-semibold tracking-[0.2em] uppercase text-kin-muted mb-2">
            Skill color framework
          </p>
          <p className="text-sm leading-relaxed text-kin-body/85 max-w-3xl mb-6">
            Each skill defines a small palette of two or three color slots. The platform reads these
            tokens and applies them at the correct brightness for each layer — the skill never
            reaches outside its allocated color space, and the platform never overrides the values.
          </p>

          {/* Token slot definitions */}
          <div className="grid grid-cols-1 gap-3 sm:grid-cols-3 mb-8">
            {[
              {
                token: "--skill-primary",
                name: "Primary",
                desc: "Full saturation. Buttons, key data values, active states inside the skill view.",
                example: "#4A90D9",
              },
              {
                token: "--skill-surface",
                name: "Surface",
                desc: "12–15% tint. Card background on home screen, section fills inside the skill.",
                example: "#4A90D914",
                isAlpha: true,
              },
              {
                token: "--skill-accent",
                name: "Accent",
                desc: "Complementary tone. Charts, secondary data categories, a second class of insight.",
                example: "#7EC8E3",
              },
            ].map((slot) => (
              <div
                key={slot.token}
                className="rounded-[18px] border border-kin-white/50 bg-kin-white/60 px-4 py-3 shadow-sm backdrop-blur-md"
              >
                <div className="flex items-center gap-2 mb-2">
                  <div
                    className="h-4 w-4 rounded-[5px] shrink-0 border border-black/08"
                    style={{
                      background: slot.isAlpha ? "#4A90D9" : slot.example,
                      opacity: slot.isAlpha ? 0.18 : 1,
                    }}
                  />
                  <code className="text-[10px] font-semibold text-kin-muted">{slot.token}</code>
                </div>
                <p className="text-xs font-semibold text-kin-black mb-0.5">{slot.name}</p>
                <p className="text-[10px] leading-relaxed text-kin-body/70">{slot.desc}</p>
              </div>
            ))}
          </div>

          {/* Three skill palette examples */}
          <p className="text-[10px] font-semibold tracking-[0.14em] uppercase text-kin-muted mb-4">
            Example palettes — skills define their own
          </p>
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
            {[
              {
                skill: "Sleep Deep Dive",
                creator: "Dr. Sara Chen",
                face: faceSaraChen,
                logo: logoSleepDeepDive,
                primary: "#4A90D9",
                surface: "#4A90D9",
                accent: "#E8A23C",
                sampleData: ["Sleep score", "84 / 100"],
                sampleAccent: ["Recovery energy", "High"],
              },
              {
                skill: "Metabolic Load",
                creator: "NutriLab",
                face: null,
                logo: null,
                primary: "#E8853A",
                surface: "#E8853A",
                accent: "#3A7EBF",
                sampleData: ["Glucose", "Stable"],
                sampleAccent: ["Hydration", "On track"],
              },
              {
                skill: "Cardio Baseline",
                creator: "Heart Institute",
                face: faceHeartInstitute,
                logo: null,
                primary: "#D9536A",
                surface: "#D9536A",
                accent: "#3E8C72",
                sampleData: ["Resting HR", "58 bpm"],
                sampleAccent: ["Recovery", "On target"],
              },
            ].map((s) => (
              <div
                key={s.skill}
                style={{
                  borderRadius: 16,
                  overflow: "hidden",
                  border: `1px solid ${s.primary}20`,
                  background: `${s.surface}08`,
                }}
              >
                {/* Palette strip */}
                <div style={{ display: "flex", height: 6 }}>
                  <div style={{ flex: 3, background: s.primary }} />
                  <div style={{ flex: 1, background: s.accent }} />
                  <div style={{ flex: 4, background: `${s.surface}18` }} />
                </div>
                {/* Mini card content */}
                <div style={{ padding: "12px 14px" }}>
                  {/* Skill header: logo + name + creator in one row */}
                  <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 8 }}>
                    {s.logo ? (
                      <img
                        src={s.logo}
                        alt=""
                        style={{
                          width: 36,
                          height: 36,
                          borderRadius: 9,
                          border: `1px solid ${s.primary}20`,
                          background: "#fff",
                          objectFit: "contain",
                          padding: 4,
                          flexShrink: 0,
                        }}
                      />
                    ) : (
                      <div
                        style={{
                          width: 36,
                          height: 36,
                          borderRadius: 9,
                          background: `${s.primary}14`,
                          border: `1px solid ${s.primary}20`,
                          flexShrink: 0,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: 15,
                          fontWeight: 700,
                          color: s.primary,
                          fontFamily: "'Cormorant Garamond', serif",
                        }}
                      >
                        {s.skill.charAt(0)}
                      </div>
                    )}
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div
                        style={{
                          fontSize: 13,
                          fontWeight: 700,
                          color: "#1F2421",
                          fontFamily: "'Cormorant Garamond', serif",
                          lineHeight: 1.2,
                        }}
                      >
                        {s.skill}
                      </div>
                      <div style={{ display: "flex", alignItems: "center", gap: 4, marginTop: 3 }}>
                        {s.face ? (
                          <img
                            src={s.face}
                            alt={s.creator}
                            style={{
                              width: 14,
                              height: 14,
                              borderRadius: "50%",
                              objectFit: "cover",
                              border: `1px solid ${s.primary}30`,
                              flexShrink: 0,
                            }}
                          />
                        ) : (
                          <div
                            style={{
                              width: 14,
                              height: 14,
                              borderRadius: "50%",
                              background: `${s.primary}20`,
                              border: `1px solid ${s.primary}30`,
                              flexShrink: 0,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontSize: 7,
                              fontWeight: 700,
                              color: s.primary,
                            }}
                          >
                            {s.creator.charAt(0)}
                          </div>
                        )}
                        <span style={{ fontSize: 9, fontWeight: 600, color: s.primary }}>
                          {s.creator}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div
                    style={{ display: "flex", flexDirection: "column", gap: 4, marginBottom: 8 }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        padding: "5px 8px",
                        borderRadius: 8,
                        background: "rgba(255,255,255,0.7)",
                        border: `1px solid ${s.primary}14`,
                      }}
                    >
                      <span style={{ fontSize: 9, color: "#4F5D56" }}>{s.sampleData[0]}</span>
                      <span style={{ fontSize: 10, fontWeight: 700, color: s.primary }}>
                        {s.sampleData[1]}
                      </span>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        padding: "5px 8px",
                        borderRadius: 8,
                        background: "rgba(255,255,255,0.7)",
                        border: `1px solid ${s.accent}20`,
                      }}
                    >
                      <span style={{ fontSize: 9, color: "#4F5D56" }}>{s.sampleAccent[0]}</span>
                      <span style={{ fontSize: 10, fontWeight: 700, color: s.accent }}>
                        {s.sampleAccent[1]}
                      </span>
                    </div>
                  </div>
                  {/* Token labels */}
                  <div style={{ display: "flex", gap: 4, marginTop: 8, flexWrap: "wrap" }}>
                    {[
                      { label: "primary", color: s.primary },
                      { label: "accent", color: s.accent },
                      { label: "surface", color: s.primary, alpha: true },
                    ].map((t) => (
                      <div
                        key={t.label}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 4,
                          padding: "2px 6px",
                          borderRadius: 5,
                          background: "rgba(0,0,0,0.03)",
                          border: "1px solid rgba(0,0,0,0.05)",
                        }}
                      >
                        <div
                          style={{
                            width: 8,
                            height: 8,
                            borderRadius: 2,
                            background: t.color,
                            opacity: t.alpha ? 0.2 : 1,
                            border: "1px solid rgba(0,0,0,0.08)",
                          }}
                        />
                        <code style={{ fontSize: 8, color: "#877e76" }}>{t.label}</code>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* ── Block F: Failure case ── */}
        <div className="mt-8 kin-surface-strong rounded-[24px] p-6 sm:p-8">
          <p className="text-xs font-semibold tracking-[0.2em] uppercase text-kin-muted mb-1">
            Failure case — where platform authority matters most
          </p>
          <p className="text-sm leading-relaxed text-kin-body/85 max-w-3xl mt-2 mb-6">
            When a skill has stale data, missing inputs, or low-confidence output, the{" "}
            <span className="font-semibold text-kin-black">platform</span> — not the skill —
            surfaces the empty state. Kin's neutral voice explains the situation. The skill's color
            stays, but the content area is replaced by a platform-controlled message. This protects
            user trust: skills should never present uncertain data as confident insight.
          </p>
          <div className="flex flex-col gap-6 sm:flex-row sm:items-start">
            <FailureCaseDemo />
            <div className="flex-1 space-y-3">
              <div className="rounded-[16px] border border-kin-olive/10 bg-kin-white/60 px-4 py-3">
                <p className="text-xs font-semibold text-kin-black mb-1">Skill color stays</p>
                <p className="text-xs text-kin-body/75">
                  The card retains the skill's lead color as tint and accent so the user can
                  identify which skill this is. Identity is preserved even in degraded state.
                </p>
              </div>
              <div className="rounded-[16px] border border-kin-olive/10 bg-kin-white/60 px-4 py-3">
                <p className="text-xs font-semibold text-kin-black mb-1">Kin speaks — factually</p>
                <p className="text-xs text-kin-body/75">
                  The message is platform-authored: short, neutral, actionable. It explains what's
                  needed, not what's wrong with the skill. No blame, no guessing.
                </p>
              </div>
              <div className="rounded-[16px] border border-kin-olive/10 bg-kin-white/60 px-4 py-3">
                <p className="text-xs font-semibold text-kin-black mb-1">CTA is platform green</p>
                <p className="text-xs text-kin-body/75">
                  The recovery action uses Kin green — a system action — not the skill's lead color.
                  This distinguishes "platform helping skill" from "skill running normally."
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* ── Block G: Non-curation rule ── */}
        <div className="mt-8 kin-surface rounded-[24px] p-6 sm:p-8">
          <p className="text-xs font-semibold tracking-[0.2em] uppercase text-kin-muted mb-2">
            The limits of curation
          </p>
          <p className="text-sm leading-relaxed text-kin-body/85 max-w-3xl mb-5">
            Curation is ordering and surfacing — not editorial control. Knowing when{" "}
            <span className="font-semibold text-kin-black">not</span> to intervene is as important
            as knowing when to curate.
          </p>
          <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
            {[
              {
                rule: "Kin does not rewrite skill output",
                detail:
                  "The home screen surfaces the skill's own words, not a platform summary. Kin adds a curation label; it does not paraphrase what the skill found.",
              },
              {
                rule: "Kin does not suppress conflicting findings",
                detail:
                  "If two skills surface different signals, both appear. Kin may note the discrepancy as a cross-skill synthesis, but does not choose a winner.",
              },
              {
                rule: "Kin does not rank by engagement",
                detail:
                  "A low-frequency but high-value skill (an annual cardiology report) must not be buried by a daily habit tracker simply because it generates more interactions.",
              },
              {
                rule: "Kin does not interpret skill content",
                detail:
                  "Curation decides what to show and when. It does not apply Kin's own interpretation to skill-generated content or add meaning the skill did not intend.",
              },
            ].map((item) => (
              <div
                key={item.rule}
                className="rounded-[18px] border border-kin-olive/10 bg-kin-white/60 px-4 py-3"
              >
                <p className="text-xs font-semibold text-kin-black mb-1">{item.rule}</p>
                <p className="text-xs leading-relaxed text-kin-body/75">{item.detail}</p>
              </div>
            ))}
          </div>
        </div>

        {/* ── Block H: At a glance ── */}
        <div className="mt-8 kin-surface rounded-[24px] p-6 sm:p-8">
          <p className="text-xs font-semibold tracking-[0.2em] uppercase text-kin-muted mb-5">
            Color by role — at a glance
          </p>
          <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
            {[
              {
                token: "Platform green",
                rule: "Interactive only",
                detail:
                  "Buttons, active nav states, confirmations. Never decorative, never a background fill.",
                dot: "bg-kin-green",
              },
              {
                token: "Lavender",
                rule: "AI signal only",
                detail:
                  "AI-generated outputs, synthesis, recommendations. Skills may not repurpose this — the rule only works if enforced everywhere.",
                dot: "bg-kin-lavender",
              },
              {
                token: "Skill lead color",
                rule: "Platform renders faithfully",
                detail:
                  "Rendered at 12–15% tint on home screen, full saturation inside the skill view. Never overridden or reassigned.",
                dot: null,
                dotHex: "#4A90D9",
              },
              {
                token: "Gold, orange, rose",
                rule: "Not in platform chrome",
                detail:
                  "Reserved for system-level alerts or individual skill use. These colors do not appear in navigation, auth, or vault surfaces.",
                dot: "bg-kin-gold",
              },
            ].map((item) => (
              <div
                key={item.token}
                className="rounded-[18px] border border-kin-white/50 bg-kin-white/60 px-4 py-3 shadow-sm backdrop-blur-md"
              >
                <div className="flex items-center gap-2 mb-2">
                  <div
                    className={`h-2 w-2 rounded-full shrink-0${item.dot ? ` ${item.dot}` : ""}`}
                    style={item.dotHex ? { background: item.dotHex } : undefined}
                  />
                  <p className="text-[10px] font-semibold tracking-[0.15em] uppercase text-kin-muted">
                    {item.token}
                  </p>
                </div>
                <p className="text-xs font-semibold text-kin-black mb-0.5">{item.rule}</p>
                <p className="text-[10px] leading-relaxed text-kin-body/70">{item.detail}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
